<template>
    <div
        class="detail-buy-content"
    >
        <div
            v-if="isLogin && !!buyAlreadyText"
            :style="{
                backgroundColor: buyColor,
            }"
            class="bought-text"
        >
            {{ buyAlreadyText }}
        </div>
        <div
            class="detail-buy-wrapper"
            :class="!buyAlreadyText ? 'box-shadow' : ''"
        >
            <div
                v-if="appDetail.join_community_info && !isSwanBox"
                class="order"
                @click.stop="toTieba"
            >
                <svg
                    class="join-community-icon"
                    viewBox="0 0 80 80" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g transform="translate(14.000000, 15.000000)">
                        <!-- eslint-disable -->
                        <path
                            d="M8,0 L44,0 C48.418278,-8.11624501e-16 52,3.581722 52,8 L52,38.3490066 C52,42.7672846 48.418278,46.3490066 44,46.3490066 L39.4451024,46.3490066 L39.4451024,46.3490 L39.4451024,54 L25.5959596,46.3490066 L8,46.3490066 C3.581722, 46.3490066 9.82407092e-14,42.7672846 0,38.3490066 L0,8 C-5.41083001e-16,3.581722 3.581722,8.11624501e-16 8,0 Z"
                            :stroke="buyColor ? buyColor : '#3183F7'" stroke-width="4"
                            fill="none" stroke-linejoin="round"
                        />
                        <rect
                            stroke="none"
                            :fill="buyColor ? buyColor : '#3183F7'" fill-rule="evenodd"
                            x="12" y="16"
                            width="28" height="4"
                            rx="2"
                        />
                        <rect
                            stroke="none"
                            :fill="buyColor ? buyColor : '#3183F7'" fill-rule="evenodd"
                            x="12" y="26"
                            width="16" height="4"
                            rx="2"
                        />
                    </g>
                </svg>
                <div class="order-text">去社区</div>
            </div>
            <div
                v-if="!isSem"
                :class="['order', isSwanBox ? 'swan-box-order' : '']"
                :style="{'margin-right': '3.0vw'}"
                @click.stop="toMergeShop"
            >
                <img
                    src="https://gamedelivery.cdn.bcebos.com/comment/cf15609bb15a3339d4d343a558974cd5.png"
                    class="order-icon"
                >
                <div class="order-text">去商城</div>
            </div>
            <div
                :class="isLogin ? 'logged-btn' : 'notlogged-btn'"
                :style="{
                    backgroundColor: buyColor,
                    width: appDetail.join_community_info ? '69vw' : '80vw',
                }"
                @click.stop="buyNow"
            >
                <div class="btn-text center">
                    <span>
                        {{ btnText }}
                    </span>
                    <span v-if="!!isLowest">
                        ￥{{ realPrice | decimal(2, 0.01) }}
                    </span>
                    <span v-if="!isLowest">
                        ￥{{ realPrice | decimal(2, 0.01) }}
                    </span>
                    <span v-if="!!isLowest" class="btn-text-isLowest">
                        史低
                    </span>
                </div>
            </div>
        </div>
        <div v-if="isSem" class="sem-notice">跳转至第三方平台，由第三方提供内容服务</div>
    </div>
</template>

<script>
import TiebaNewWakeUp from '@baidu/tieba-new-wakeup';
import {getQueryString, getUrlParams} from '@/utils/url';
import {openPage} from '@/utils/utility';
import {generateToken} from '@/utils/tiebaUtility';
import {copy} from '@/utils/browser';
import {colorRgb} from '@/utils/tool';
export default {
    props: {
        btnText: {
            type: String,
            default: '',
        },
        buyColor: {
            type: String,
            default: 'rgba(0,0,0,0.2)',
        },
        isLogin: {
            type: Boolean,
            default: false,
        },
        buyAlreadyText: {
            type: String,
            default: '',
        },
        skuId: {
            type: Number,
            default: 0,
        },
        // 品专进来购买按钮跳转链接
        semUrl: {
            type: String,
            default: '',
        },
        isLowest: {
            type: Boolean,
            default: false,
        },
        realPrice: {
            type: Number,
            required: false,
        },
        priceTrendText: {
            type: String,
            default: '',
        },
        appDetail: {
            type: Object,
            required: true,
        },
    },
    computed: {
        btnColorRgbaInProgress() {
            return colorRgb(this.buyColor, 0.09);
        },
    },
    watch: {
        appDetail: {
            handler() {
                if (this.appDetail.join_community_info) {
                    this.$root.sendLog('display', 'communityBtn_display');
                }
            },
        },
    },
    data() {
        return {
            isSem: false,
            srcId: 0,
            isSwanBox: false,
        };
    },
    created() {
        this.isSem = getQueryString('from') === 'sem';
        this.srcId = getQueryString('srcid');
        if (/swan-baiduboxapp/.test(navigator.userAgent.toLowerCase())) {
            this.isSwanBox = true;
        }
    },
    mounted() {
        this.doDisplayLog('buy');
        this.doDisplayLog('store_sw');
    },
    methods: {
        buyNow() {
            if (!this.isSem) {
                this.openPanel();
            }
            else {
                window.location.href = `${this.semUrl}`;
            }
            this.doClickLog('buy', {srcId: this.srcId, skuId: this.skuId, moduleName: '底部购买', btnType: this.btnText});
        },
        toTieba() {
            this.$root.sendLog('click', 'communityBtn_click');
            const token = this.getToken();
            copy(token);
            this.$root.report(token).then(() => {
                TiebaNewWakeUp.init({
                    page: 'frs',
                    param: {
                        obj_source: 'wise',
                        kw: this.appDetail.join_community_info?.forum_name || '',
                        fid: this.appDetail.join_community_info?.forum_id || '',
                        locate: 'outer_game_joinsq',
                    },
                    androidShoubaiGoCenterPage: false,
                    androidDownUrl: this.appDetail.join_community_info.download_url,
                });
            });
        },
        getToken() {
            const config = {
                page: 'frs',
                param: {
                    kw: this.appDetail.join_community_info?.forum_name || '',
                    fid: this.appDetail.join_community_info?.forum_id || '',
                    extdata: {}, // 新schema打点
                    track: '', // fe打点
                    locate: 'gamecenter',
                },
            };
            return generateToken(config);
        },
        openPanel() {
            this.$emit('openPanel');
        },
        toOrderPage() {
            this.doClickLog('myOrder', {srcId: this.srcId, skuId: this.skuId, moduleName: '底部购买'});
            openPage('orderList', getUrlParams());
        },
        toMergeShop() {
            this.doClickLog('store_ck', {});
            window.location.href = 'https://gamecenter.baidu.com/static/game/mergeshop.html?channel=2001';
        },
        doClickLog(value, obj, pos = '') {
            let content = {
                value: value,
                ext: {
                    id: '',
                    ext: Object.assign(Object.assign(obj, {sourceMap: 'channel'}), this.$root.extData),
                    pos: pos,
                },
            };
            this.$logger.click(content);
        },
        doDisplayLog(val) {
            this.$logger.display({
                value: val,
                ext: {
                    item: [
                        {
                            id: '',
                            ext: Object.assign({
                                srcId: this.srcId,
                                skuId: this.skuId,
                                moduleName: '底部购买',
                                btnType: this.btnText,
                            }, this.$root.extData),
                            pos: '',
                        },
                    ],
                },
            });
        },
    },
};

</script>

<style lang="scss" scoped>
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;

    *{
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color:transparent;
    }

    .center {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .detail-buy-content {
        width: px2rem(1242);
        position: fixed;
        bottom: 0;
        .bought-text {
            font-size: px2rem(42);
            height: px2rem(80);
            bottom: px2rem(192);
            text-align: center;
            color: #ffffff;
            line-height: px2rem(80);
            box-shadow: 0 px2rem(-2) px2rem(5) #eee;
            background-color: #38f;
        }
        .box-shadow {
            box-shadow: 0 px2rem(-2) px2rem(5) #eee;
        }
        .detail-buy-wrapper{
            height: px2rem(192);
            background-color: #fff;
            display: flex;
            align-items: center;
            flex-flow: row;
            position: relative;
            .notlogged-btn {
                width: px2rem(1140);
                height: px2rem(132);
                line-height: px2rem(132);
                border-radius: px2rem(66);
                background-color: #38f;
                font-size: px2rem(54);
                color: #fff;
                text-align: center;
                margin: 0 px2rem(51);
            }
            .btn-text {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .lastLowest {
                margin-left: 10px;
            }
            .btn-text-isLowest {
                box-sizing: border-box;
                height: 60px;
                background: #FFFFFF;
                border-radius: 9px;
                color: #3388FF;
                margin-left: 18px;
                font-family: PingFangSC-Medium;
                font-size: 36px;
                text-align: center;
                line-height: px2rem(50);
                padding: 5px 5px;
            }
            .go-community {
                margin-left: 51px;
                margin-right: 35px;
            }
            .go-community-text {
                position: absolute;
                top: 55px;
                transform: translate(-50%);
                display: flex;
                align-items: center;
                font-size: 54px;
                justify-content: center;
            }
            .logged-btn {
                width: px2rem(1000);
                height: px2rem(132);
                line-height: px2rem(132);
                border-radius: px2rem(66);
                background-color: #38f;
                font-size: px2rem(54);
                color: #fff;
            }
            .order {
                white-space: nowrap;
                margin: 0 px2rem(15) 0 px2rem(15);
                text-align: center;
                font-size: px2rem(36);
                .order-icon {
                    width: 80px;
                    height: 80px;
                }
                .join-community-icon {
                    width: 80px;
                    height: 80px;
                }
                .order-text {
                    width: 126px;
                    height: 33px;
                    opacity: 0.55;
                    font-family: PingFangSC-Regular;
                    font-size: 33px;
                    color: #000000;
                    text-align: center;
                    line-height: 33px;
                    font-weight: 400;
                }
            }
            .swan-box-order {
                margin-left: px2rem(60);
            }
        }
        .sem-notice {
            background-color: #fff;
                font-size: px2rem(36);
                color: #CCCCCC;
                text-align: center;
                line-height: px2rem(96);
                margin-top: px2rem(-30);
        }
    }
</style>